module.exports = __webpack_public_path__ + "img/swipe (5).d4450917.jpg";